import script from "./games-filter-category-options.vue?vue&type=script&lang=ts&setup=true"
export * from "./games-filter-category-options.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__